
import { Dispatch } from 'redux';
import { LoginService } from "../../services/LoginService";
import { orgapi } from "../../ApiNames";

export const fetchdatasuccess = (data:any)=>({
    type : 'fetch_data_success',
    payload:data,
});
export const fetchreportdatasuccess = (reportdata:any)=>({
    type : 'fetch_report_data_success',
    payload:reportdata,
});
export const fetchdata = (uid:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {userid:uid,q:3};
            const apiname = orgapi.orgfundreports;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdatasuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};

export const fetchgendata = (uid:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {userid:uid};
            const apiname = orgapi.orgfunreport;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchreportdatasuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};

